export const RESET_VEHICLE = 'RESET_VEHICLE'

export const resetVehicle = () => {
  return dispatch => dispatch({
    type: RESET_VEHICLE
  })
}
